import { Parcel, parcelDecoder } from './Parcel'
import { ParcelDispatcher, parcelDispatcherDecoder } from './ParcelDispatcher'
import { Decoder, field, object } from 'json-bouncer'

export namespace PrismaRequestMarkAsDispatchedResponse {

    export interface M {
        readonly parcelDispatcher: ParcelDispatcher
        readonly parcel: Parcel
    }

    export function decoder(): Decoder<M> {
        return object(
            {
                parcelDispatcher: field('parcelDispatcher', parcelDispatcherDecoder()),
                parcel: field('parcel', parcelDecoder()),
            },
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestMarkAsDispatchedResponse.ts